/**
 * Kratome — client-side batch lookup.
 * Reads assets/batch-reports-demo.json, which ships with clearly marked
 * DEMONSTRATION data. Replace that file's contents (or migrate to a
 * metaobject-driven feed once Admin API access is connected) with real,
 * current Certificates of Analysis before launch.
 */
(function () {
  "use strict";

  function init() {
    var form = document.querySelector("[data-batch-search-form]");
    var input = document.querySelector("[data-batch-search-input]");
    var result = document.querySelector("[data-batch-search-result]");
    var dataUrl = form && form.dataset.source;
    if (!form || !input || !result || !dataUrl) return;

    var cache = null;

    function fetchData() {
      if (cache) return Promise.resolve(cache);
      return fetch(dataUrl)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          cache = json.batches || [];
          return cache;
        });
    }

    function render(record, query) {
      if (!record) {
        result.innerHTML =
          '<div class="batch-result batch-result--empty">' +
          "<p>We couldn&rsquo;t find a report for <strong>" + escapeHtml(query) + "</strong>. " +
          'Double-check the batch number on your label, or <a href="/pages/contact">contact us</a> and we’ll send it directly.</p>' +
          "</div>";
        return;
      }
      result.innerHTML =
        '<div class="batch-result">' +
        '<div class="batch-result__head"><h3>' + escapeHtml(record.batch) + "</h3><span>" + escapeHtml(record.series || "") + "</span></div>" +
        '<dl class="batch-result__grid">' +
        "<div><dt>Harvest date</dt><dd>" + escapeHtml(record.harvestDate || "—") + "</dd></div>" +
        "<div><dt>Test date</dt><dd>" + escapeHtml(record.testDate || "—") + "</dd></div>" +
        "<div><dt>Laboratory</dt><dd>" + escapeHtml(record.laboratory || "—") + "</dd></div>" +
        "<div><dt>Alkaloid content</dt><dd>" + escapeHtml(record.alkaloidContent || "—") + "</dd></div>" +
        "<div><dt>Heavy metals</dt><dd>" + escapeHtml(record.heavyMetals || "—") + "</dd></div>" +
        "<div><dt>Microbiological</dt><dd>" + escapeHtml(record.microbiological || "—") + "</dd></div>" +
        "<div><dt>Moisture content</dt><dd>" + escapeHtml(record.moistureContent || "—") + "</dd></div>" +
        "</dl>" +
        '<p class="batch-result__demo-notice">Demonstration record — not a genuine Certificate of Analysis.</p>' +
        "</div>";
    }

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var query = (input.value || "").trim().toUpperCase();
      if (!query) return;
      result.setAttribute("aria-busy", "true");
      fetchData().then(function (batches) {
        var match = batches.filter(function (b) { return (b.batch || "").toUpperCase() === query; })[0];
        result.removeAttribute("aria-busy");
        render(match, input.value.trim());
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
